var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.889 1.10172C6.889 0.494163 7.38679 0 8 0C8.61321 0 9.111 0.494163 9.111 1.10172V7.42663C9.111 8.03418 8.61321 8.52834 8 8.52834C7.38679 8.52834 6.889 8.03418 6.889 7.42663V1.10172ZM16 8.05945C16 12.4371 12.411 16 8 16C3.58881 16 0 12.4375 0 8.05945C0 5.61255 1.11046 3.33959 3.04762 1.82209C3.39245 1.55336 3.89085 1.61161 4.16175 1.95236C4.43213 2.29302 4.37347 2.78638 4.03051 3.05508C2.47663 4.2723 1.5852 6.09653 1.5852 8.05945C1.5852 11.572 4.46357 14.4294 8.00068 14.4294C11.5372 14.4294 14.4155 11.5719 14.4155 8.05945C14.4155 6.09581 13.5233 4.27092 11.9681 3.05304C11.6252 2.78381 11.5665 2.29044 11.8369 1.95035C12.108 1.60991 12.6082 1.55114 12.9501 1.81991C14.8888 3.33871 16 5.61195 16 8.05945Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.4e61ae293a6707bc5e9f489016ce224f.svg";
export { ForwardRef as ReactComponent };